export const BUILD_VERSION = '1775745223';
